module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('div', {
    staticClass: "modal__backdrop",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__inner"
  }, [_c('h3', {
    staticClass: "c-accent mt",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.modal.title))]), _vm._v(" "), (_vm.modal.copy) ? _c('p', {
    staticClass: "p small",
    domProps: {
      "innerHTML": _vm._s(_vm.modal.copy)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("modal-body"), _vm._v(" "), _vm._t("modal-footer")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7269da66"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Modal.vue
// module id = 258
// module chunks = 2